module.exports = __webpack_public_path__ + "img/banner.b9c51ad6.jpg";